// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/radio-channel-control.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/radio-channel-control/radio-channel-control.js';

mount([g0]);
